import { render, staticRenderFns } from "./ProgressBarWithRuler.global.vue?vue&type=template&id=38904f56&scoped=true&lang=pug&"
import script from "./ProgressBarWithRuler.global.vue?vue&type=script&lang=ts&"
export * from "./ProgressBarWithRuler.global.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBarWithRuler.global.vue?vue&type=style&index=0&id=38904f56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38904f56",
  null
  
)

export default component.exports